import React from "react";

interface TextBoxProps {
    label: string;
    value: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    placeholder?: string;
    labelWidth?: string;
    name?: string;
    type?: "text" | "number";
    containerStyle?: React.CSSProperties;
    labelStyle?: React.CSSProperties;
    inputStyle?: React.CSSProperties;
}

export const TextBox: React.FC<TextBoxProps> = ({
    label,
    value,
    onChange,
    placeholder = "",
    labelWidth = "100%",
    name,
    containerStyle,
    labelStyle,
    inputStyle
}) => {
    return (
        <div className="row" style={containerStyle}>
            <label
                className="label"
                style={{ flex: `0 0 ${labelWidth}`, ...labelStyle }}
            >
                {label}
            </label>

            <div>
                <input
                    type="text"
                    name={name}
                    value={value}
                    onChange={onChange}
                    placeholder={placeholder}
                    className="textbox"
                    style={inputStyle}
                />
            </div>
        </div>
    );
};